import { request } from 'umi'
import type { AccountQueryParams } from './components/AccountModal'
import type { AddCustomerParams, CreateCustomerInfoHm } from './data.d'

export async function saveCustomer(params: AddCustomerParams) {
  return request('/hm/customer/edit', {
    method: 'POST',
    data: {
      ...params
    }
  })
}
export async function ccrcSaveCustomer(params: any) {
  return request('/manage/customer/administrator/insert', {
    method: 'POST',
    data: {
      ...params
    }
  })
}
export async function ccrcUpdateCustomer(params: any) {
  return request('/manage/customer/administrator/update', {
    method: 'PUT',
    data: {
      ...params
    }
  })
}


export async function createAnonymousCustomer() {
  return request('/hm/customer/create-anonymous', {
    method: 'POST'
  })
}

export async function fetchDuplicateCustomer(params: AccountQueryParams) {
  return request('/hm/customer/list', {
    method: 'GET',
    params
  })
}

// 批量添加客户
export async function addCustomers(params: CreateCustomerInfoHm[]) {
  return request('/hm/customer/batch-edit', {
    method: 'POST',
    data: params
  })
}

// 获取证件类型列表
export async function getIdTypeList(params: { category: string }) {
  return request('/core/dict/list', {
    method: 'GET',
    params
  })
}

// 获取国家和区号列表
export async function getNations() {
  return request('/core/customer/account/getNations')
}

